import { useState, useEffect, useContext } from "react";
import { Comment, ReportComment } from '../../../interfaces/news'
import { Segment, CloseIcon, Flex, Chat, ChatMessage, Avatar, Button, TextArea } from "@fluentui/react-northstar"
import { formatDistance } from 'date-fns'
import { SocialAPI } from "../../../api/SocialAPI";
import { TeamsFxContext } from "../../Context";
import { ErrorWithCode } from "@microsoft/teamsfx";

export function CommentReport(props: { commentToReport: Comment, toggleCommentReport: any, refreshSocial: any }) {
    const [reportText, setReportText] = useState('');
    const handleReportTextChange = (e: any) => { setReportText(e.target.value); };
    const { themeString, teamsUserCredential } = useContext(TeamsFxContext);
    const [token, setToken] = useState<string>();
    const [tenantId, setTenantId] = useState<string>();
    const scope = [`${process.env.REACT_APP_IDENTIFIER_URI}/access_as_user`];

    useEffect(() => {
        setReportText('')
        teamsUserCredential?.getUserInfo().then((userInfo) => {
            setTenantId(userInfo.tenantId);
            teamsUserCredential!.getToken(scope).then((tokenResponse) => {
                setToken(tokenResponse!.token)
            }).catch((err: ErrorWithCode) => {
                if (err.code === 'UiRequiredError') {
                    teamsUserCredential!.login(scope).then(() => {
                        teamsUserCredential!.getToken(scope).then((tokenResponse) => {
                            setToken(tokenResponse!.token)
                        })
                    })
                }
            })
        })
    }, [])

    return (
        <Segment color="orange">
            <Flex gap="gap.smaller">
                <Chat
                    styles={{ marginBottom: '5px', width: '100%' }}
                    items={[
                        {
                            gutter: (<Avatar name={props.commentToReport.HierarchyFriendlyName} image={props.commentToReport.UserImageUrl} />),
                            key: 'commentToReport',
                            message: (
                                <ChatMessage
                                    author={props.commentToReport?.HierarchyFriendlyName}
                                    content={props.commentToReport?.CommentText}
                                    timestamp={formatDistance(new Date(props.commentToReport.AuditDate), new Date())}
                                />
                            ),
                        },
                    ]}
                />
                <Button icon={<CloseIcon />} iconOnly title="Close" size="small" style={{ marginLeft: "auto" }} onClick={props.toggleCommentReport} />
            </Flex>
            <Flex gap="gap.smaller">
                <TextArea id="reportText"
                    name="reportText"
                    value={reportText}
                    onChange={handleReportTextChange}
                    fluid
                    placeholder="Report reason..."
                    style={{ marginBottom: '15px' }} />
                <Button content="Report" tinted style={{ margin: "auto" }} onClick={async (event) => {
                    if (reportText.length === 0) {
                        return
                    }
                    if (token && tenantId) {
                        const reportComment: ReportComment = {
                            CommentId: props.commentToReport.CommentId,
                            ReportReasonText: reportText
                        }

                        await SocialAPI.reportComment(reportComment, token, tenantId)
                            .then(async (response) => {
                                console.log(response);
                                props.refreshSocial();
                            })
                            .catch((error) => {
                                console.error(error.response.status);
                            })
                    }
                }} />
            </Flex>
        </Segment>)
}
